<div class="return-products-dialog" [mmTestId]="'RETURN_PRODUCTS_DIALOG.CONTAINER'">
  <mm-dialog-title>{{title}}</mm-dialog-title>
  <div class="return-products-dialog__body">
    
    <div class="return-products-dialog__text">
      <p>{{'PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_PRODUCTS_DIALOG.BODY' | translate}}</p>
      <ng-container *ngIf="(showRefundFeeDisclaimer$ | async ) && isMetroInOrder" >
        {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_PRODUCT_DIALOG.REFUND_FEE_1' | translate }}
        <a class="return-product-dialog__link" target="_blank" href="{{faqUrl}}">{{ 'PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_PRODUCT_DIALOG.REFUND_FEE_2' | translate }}</a>
      </ng-container>
    </div>
    <mm-field *ngIf="(returnReasons$ | async)?.length">
      <mm-label>{{'PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_PRODUCTS_DIALOG.SELECT_LABEL' | translate}}</mm-label>
      <mm-select [options]="returnReasons$ | async"
                 [displayedProperty]="'title'"
                 [placeholder]="'PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_PRODUCTS_DIALOG.SELECT_REASONS_PLACEHOLDER' | translate"
                 [formControl]="returnReasonControl"></mm-select>
      <span
        *ngIf="returnReasonControl.dirty && returnReasonControl.errors?.required"
        class="return-products-dialog__error-message">
        {{'REGULAR.ERROR_MESSAGES.MANDATORY' | translate}}</span>
    </mm-field>
  </div>
  <mm-dialog-footer>
    <button mm-button
            color="ghost"
            mmDialogClose
            [mmTestTarget]="'dialog-cancel-btn'">
      {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_PRODUCTS_DIALOG.CANCEL_BUTTON' | translate }}
    </button>

    <button mm-button
            color="warning"
            (click)="onConfirm()"
            [mmTestTarget]="'dialog-submit-btn'">
      {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_PRODUCTS_DIALOG.CONFIRM_BUTTON' | translate }}
    </button>
  </mm-dialog-footer>
</div>
